import { render, staticRenderFns } from "./CategoriesTable.vue?vue&type=template&id=157c9b26&scoped=true&"
import script from "./CategoriesTable.vue?vue&type=script&lang=ts&"
export * from "./CategoriesTable.vue?vue&type=script&lang=ts&"
import style0 from "./CategoriesTable.vue?vue&type=style&index=0&id=157c9b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c9b26",
  null
  
)

export default component.exports